import { Diamond } from "components/icons/generated";
import Badge from "ds/components/Badge";
import Box from "ds/components/Box";
import Tooltip from "ds/components/Tooltip";
import Typography from "ds/components/Typography";

type CustomListBoxItemProps = {
  value: string;
  label: string;
  disabled?: boolean;
  tooltip?: string;
};

const CustomListBoxItem = ({ label, disabled, tooltip }: CustomListBoxItemProps) => {
  return (
    <Tooltip
      active={disabled}
      placement="left"
      offset={16}
      widthMode="maxWidthSm"
      on={(props) => (
        <Box direction="row" align="center" gap="medium" fullWidth {...props}>
          <Typography
            {...props}
            tag="span"
            variant="p-body3"
            color={disabled ? "disabled" : "primary"}
          >
            {label}
          </Typography>
          {disabled && (
            <Badge variant="purple" type="strong" startIcon={Diamond} iconOnly {...props} />
          )}
        </Box>
      )}
    >
      {tooltip}
    </Tooltip>
  );
};

export default CustomListBoxItem;
